export default __webpack_public_path__ + "static/media/react-logo.c2861c4d.png";